import {
  LOADING_TOGGLE_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOGOUT_ACTION,
  SIGNUP_CONFIRMED_ACTION,
  SIGNUP_FAILED_ACTION,
  AUTH_CHECKED_ACTION,
} from "../actions/AuthActions";

const initialState = {
  auth: {
    email: "",
    idToken: "",
    localId: "",
    expiresIn: "",
    refreshToken: "",
  },
  role: "",
  isAuthenticated: false,
  errorMessage: "",
  successMessage: "",
  showLoading: false,
  authChecked: false, // Track if we've checked localStorage
};

export function AuthReducer(state = initialState, action) {
  console.log("AuthReducer action", action.role);
  if (action.type === SIGNUP_CONFIRMED_ACTION) {
    return {
      ...state,
      auth: action.payload,
      errorMessage: "",
      successMessage: "Signup Successfully Completed",
      showLoading: false,
      role: action.role,
      isAuthenticated: true,
      authChecked: true,
    };
  }
  if (action.type === LOGIN_CONFIRMED_ACTION) {
    console.log("AuthReducer action l", action.role);

    return {
      ...state,
      auth: action.payload,
      errorMessage: "",
      successMessage: "Login Successfully Completed",
      showLoading: false,
      role: action.role,
      isAuthenticated: true,
      authChecked: true,
    };
  }

  if (action.type === LOGOUT_ACTION) {
    return {
      ...state,
      errorMessage: "",
      successMessage: "",
      auth: {
        email: "",
        idToken: "",
        localId: "",
        expiresIn: "",
        refreshToken: "",
      },
      role: "",
      isAuthenticated: false,
      authChecked: true,
    };
  }

  if (
    action.type === SIGNUP_FAILED_ACTION ||
    action.type === LOGIN_FAILED_ACTION
  ) {
    return {
      ...state,
      errorMessage: action.payload,
      successMessage: "",
      showLoading: false,
    };
  }

  if (action.type === LOADING_TOGGLE_ACTION) {
    return {
      ...state,
      showLoading: action.payload,
    };
  }

  if (action.type === AUTH_CHECKED_ACTION) {
    return {
      ...state,
      authChecked: true,
    };
  }

  return state;
}
